/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Last_VerifiedInputs */

const cs_portals_last_verified = /** @type {(inputs: Portals_Last_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naposledy ověřeno`)
};

const en_portals_last_verified = /** @type {(inputs: Portals_Last_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last verified`)
};

/**
* | output |
* | --- |
* | "Last verified" |
*
* @param {Portals_Last_VerifiedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_last_verified = /** @type {((inputs?: Portals_Last_VerifiedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Last_VerifiedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_last_verified(inputs)
	return cs_portals_last_verified(inputs)
});